import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './RegisterModern.css'; // Shared CSS

const Register = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('https://harmoni-chat-6.onrender.com/api/auth/register', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setUser(res.data.user);
      navigate('/login');
    } catch (err) {
      alert('Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-glass-card">
        
        {/* Left Side: Visuals */}
        <div className="auth-art-col">
          <div className="floating-ui-element">🚀</div>
          <h2>Join Harmoni</h2>
          <p>Start your journey today.</p>
        </div>

        {/* Right Side: Form */}
        <div className="auth-form-col">
          <div className="auth-header">
            <h1>Create Account</h1>
            <p>
              Already have an account?{' '}
              <Link to="/login" className="auth-link">Log in</Link>
            </p>
          </div>

          <form onSubmit={handleSubmit} autoComplete="off">
            
            <div className="input-group">
              <input
                id="username"
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                required
                placeholder=" " 
              />
              <label htmlFor="username">Username</label>
            </div>

            <div className="input-group">
              <input
                id="password"
                type="password"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                required
                placeholder=" "
              />
              <label htmlFor="password">Password</label>
            </div>

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Creating...' : 'Sign Up'}
            </button>
            
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default Register;